// Tema Black/White persistido por navegador (conveniência local).
export type Theme = "black" | "white";
const KEY = "pokechess:theme";

export function loadTheme(): Theme {
  let saved: string | null = null;
  try {
    saved = localStorage.getItem(KEY);
  } catch {
    /* modo privado / storage bloqueado */
  }
  if (saved === "black" || saved === "white") return saved;
  return matchMedia("(prefers-color-scheme: light)").matches ? "white" : "black";
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", theme === "black" ? "#16181d" : "#e9edf2");
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* ignora */
  }
}

export function toggleTheme(): Theme {
  const next: Theme = document.documentElement.dataset.theme === "black" ? "white" : "black";
  applyTheme(next);
  return next;
}
